import {useTranslation} from "react-i18next";
import {Languages} from "../locale/Languages";

export function useLocale() : string{
    const {i18n} = useTranslation();
    const locale = i18n.language;
    return Languages.find(l => locale.startsWith(l.code))?.code ?? Languages[0].code;
}